'use strict';

var React = require('react');

var SvgFlagIcon = function SvgFlagIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m4.964 4.02.237-.127a4.808 4.808 0 0 1 5.392.592 2.09 2.09 0 0 0 2.25.304l.844-.397a1.973 1.973 0 0 1 2.813 1.786v5.044a2.37 2.37 0 0 1-1.361 2.145l-1.363.64a4.093 4.093 0 0 1-4.406-.595 2.832 2.832 0 0 0-3.176-.349l-1.194.637v2.05a.75.75 0 0 1-1.5 0v-11.5a.75.75 0 0 1 1.464-.23Zm.943 1.196a3.308 3.308 0 0 1 3.71.408 3.59 3.59 0 0 0 3.865.522l.843-.397a.473.473 0 0 1 .675.429v5.044a.87.87 0 0 1-.5.787l-1.362.642a2.593 2.593 0 0 1-2.792-.378 4.332 4.332 0 0 0-4.858-.533l-.488.26v-6.115a.31.31 0 0 1 .163-.272l.744-.397Z"
  }));
};
SvgFlagIcon.displayName = "FlagIcon";

exports.SvgFlagIcon = SvgFlagIcon;
